import React from 'react';

const industryData = [
  { label: "Total Industry Revenue", value: "$791 Millions" },
  { label: "Industry Participants", value: "638 Businesses" },
  { label: "Avg Revenue per Business", value: "$12,39,811.91" },
  { label: "Average Employees", value: "3.1" },
  { label: "Industry Revenue Volatility", value: "Medium" },
  { label: "Growth Industry Revenue (12 mths)", value: "-1.67%", trend: "down" },  // Trend info
  { label: "Employment Cost Growth", value: "6.83%", trend: "up" },  // Trend info
  { label: "Average Employee Wages", value: "$61,421.32" },
  { label: "Business Concentration Level", value: "Low" },
  { label: "Industry Capital Intensity", value: "Low" },
  { label: "Industry Life Cycle Stage", value: "Mature" },
  { label: "Technology Change", value: "Low" },
  { label: "Barriers to Entry", value: "Medium" },
];

const IndustryOverview1 = () => {
  return (
    <div className="container mt-5">
      <h2 className="text-center mb-4">INDUSTRY INSIGHTS -</h2>
      <div className="row">
        {industryData.map((data, index) => (
          <div key={index} className="col-md-4 mb-4">
            <div className="card shadow-lg rounded">
              <div className="card-body">
                <h5 className="card-title mb-3">{data.label}</h5>
                <p className="card-text">
                  {data.value}
                  {data.trend && data.trend === "up" && (
                    <span className="text-success ms-2">
                      <i className="ti-arrow-up" /> {data.trend}
                    </span>
                  )}
                  {data.trend && data.trend === "down" && (
                    <span className="text-danger ms-2">
                      <i className="ti-arrow-down" /> {data.trend}
                    </span>
                  )}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default IndustryOverview1;
